<template>
  <component
    v-if="props.comp"
    :is="props.comp.is"
    v-bind="props.comp.props"
    v-dynamic-events="props.comp.events || []"
  >
    {{ props.comp.content ? props.comp.content : "" }}
    
    <template v-for="(child, ind) in props.comp.children">
      <ModalView :comp="child" v-slot:[child.slot] />
    </template>
    
  </component>
</template>

<script setup lang="ts">
import ModalView from './ModalView.vue';

const props = defineProps(['comp']);

const vDynamicEvents = {
      bind: function (el, binding, vnode) {
        const allEvents = binding.value;

        Object.keys(allEvents).forEach((event) => {
          vnode.componentInstance.$on(event, (eventData) => {
            vnode.context.proxyEvent(event, allEvents[event], eventData);
          });
        });
      },
      unbind: function (el, binding, vnode) {
        vnode.componentInstance.$off();
      },
    }


</script>
